import { PoItemModel } from "./poitem.model";

export class PoItemListModel {
    sourceData: Array<PoItemModel> = new Array<PoItemModel>();
    totalCount: number = 0;
}
